export default{
    Basicinfoxu:{
        titleState:{
            title1:'Username：',
            title2:'Mobile：',
            title3:'Identity：',
            title4:'Individual Verification',
            title5:'Enterprise Verification',
            title6:'Security Settings',
        },
        showList:{
            show1:'Login Password',
            show2:'Regular password changes are recommended. A strong password enhances account security',
            show3:'Security Phone',
            show4:'Your security phone can be used for login, password reset, and other security verifications',
            show5:'Payment Password',
            show6:'Required for credit payments to ensure transaction security',
            show7:'Security Tips',
            show8:'Beware of phishing sites. Do not trust payment/product links sent via messaging tools. Stay alert against online scams.',
        },
        Passwordinfo:{
            pass1:'Change Password',
            pass2:'Current Password',
            pass3:'New Password',
            pass4:'Confirm Password',
            pass5:'Set Payment Password',
            pass6:'Enter 6-digit numeric payment password',
            pass7:'Re-enter 6-digit numeric payment password',
            pass8:'Passwords do not match',
            pass9:'Enter password',
            pass10:'Password changed successfully!',
            pass11:'Password must contain 6-12 characters (letters, numbers, or underscores)',
        },
        btnList:{
            btn1:'Modify',
            btn2:'Set Password',
            btn3:'Cancel',
            btn4:'Confirm'
        }
    }
}